import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

// Context
import { AuthProvider } from "./context/AuthContext";

// Layout
import Layout from "./components/Layout";
import AdminLayout from "./components/AdminLayout";
import MemberLayout from "./components/MemberLayout";

// Public Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import MembershipPage from "./pages/MembershipPage";
import ApplicationPage from "./pages/ApplicationPage";
import FoundingMembersPage from "./pages/FoundingMembersPage";
import MembersPage from "./pages/MembersPage";
import EventsPage from "./pages/EventsPage";
import NewsPage from "./pages/NewsPage";
import DocumentsPage from "./pages/DocumentsPage";
import ContactPage from "./pages/ContactPage";
import VerifyPage from "./pages/VerifyPage";

// Auth Pages
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";

// Payment Pages
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";

// Member Pages
import MemberDashboard from "./pages/member/MemberDashboard";
import MemberCertificate from "./pages/member/MemberCertificate";

// Admin Pages
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminApplications from "./pages/admin/AdminApplications";
import AdminMembers from "./pages/admin/AdminMembers";
import AdminCertificates from "./pages/admin/AdminCertificates";
import AdminPayments from "./pages/admin/AdminPayments";
import AdminEvents from "./pages/admin/AdminEvents";
import AdminNews from "./pages/admin/AdminNews";
import AdminDocuments from "./pages/admin/AdminDocuments";
import AdminFoundingMembers from "./pages/admin/AdminFoundingMembers";
import AdminCMSPages from "./pages/admin/AdminCMSPages";
import AdminCMSLeadership from "./pages/admin/AdminCMSLeadership";
import AdminCMSSettings from "./pages/admin/AdminCMSSettings";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="membership" element={<MembershipPage />} />
            <Route path="apply" element={<ApplicationPage />} />
            <Route path="founding-members" element={<FoundingMembersPage />} />
            <Route path="members" element={<MembersPage />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="news" element={<NewsPage />} />
            <Route path="documents" element={<DocumentsPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="verify" element={<VerifyPage />} />
            <Route path="verify/:certificateNumber" element={<VerifyPage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="register" element={<RegisterPage />} />
            <Route path="payment/success" element={<PaymentSuccessPage />} />
            <Route path="payment/cancel" element={<PaymentCancelPage />} />
          </Route>

          {/* Member Routes */}
          <Route path="/member" element={<MemberLayout />}>
            <Route index element={<MemberDashboard />} />
            <Route path="dashboard" element={<MemberDashboard />} />
            <Route path="certificate" element={<MemberCertificate />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="applications" element={<AdminApplications />} />
            <Route path="members" element={<AdminMembers />} />
            <Route path="certificates" element={<AdminCertificates />} />
            <Route path="payments" element={<AdminPayments />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="news" element={<AdminNews />} />
            <Route path="documents" element={<AdminDocuments />} />
            <Route path="founding-members" element={<AdminFoundingMembers />} />
            <Route path="cms/pages" element={<AdminCMSPages />} />
            <Route path="cms/leadership" element={<AdminCMSLeadership />} />
            <Route path="cms/settings" element={<AdminCMSSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
